.form-subtitle {
  margin-top: calc(var(--spacer)* 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.toggle-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

#general-display-issue-visibility-antimalware-show-after-field {
  --form-field-label-width: 210px;
}
